import {ModalController} from '../../../../../modules/core/abstracts/controllers/modal-controller';

class VouchersAndTicketsModalController extends ModalController {

    constructor($uibModalInstance, invoiceId, $http, $q, InvoiceActionsService, SweetAlert) {
        super($uibModalInstance);
        this.invoiceId = invoiceId;
        this.api = $http;
        this.queue = $q;
        this.invoiceActionsService = InvoiceActionsService;
        this.sweetAlert = SweetAlert;

        this.invoice = null;
        this.step1Information = null;
        this.loading = true;
        this.error = false;
        this.currentStep = 1;
        this.showVoucherPrintButton = false;

        this.loadInvoice();
    }

    loadInvoice() {
        this.api.get(`billing/invoices/${this.invoiceId}?include=rsvps`).then((response) => {
            this.invoice = response.data.data;

            this.api.get(`vouchers/generation-information/invoice/${this.invoiceId}`).then((response) => {
                this.step1Information = response.data.data;
                this.loading = false;
            });
        }, () => {
            this.loading = false;
            this.error = true;
                this.errorMessage = 'Error while getting voucher creation information';
        });
    }

    async createVouchersAndTickets() {
        this.loading = true;
        this.currentStep = 2;

        if(this.invoice.rsvps.data.filter(rsvp => !!rsvp.area_config.ticket_template_id).length > 0) {
            try {
                const ticketResponse = await this.api.post(`tickets/create-for-invoice/${this.invoice.id}`);
                this.createdTickets = ticketResponse.data.data;
            } catch(e) {
                console.error('error on ticket creation', e)
                this.loading = false;
                this.error = true;
                this.errorMessage = 'Error while creating tickets';
                return;
            }
        }

        try {
            const vouchersResponse = await this.api.post(`vouchers/generate/invoice/${this.invoiceId}`);

            this.step2Information = vouchersResponse.data.data;
            _.each(this.step2Information, (billable) => {
                _.each(billable.vouchers, (voucher) => {
                    if(voucher.template.needs_print) {
                        this.showVoucherPrintButton = true;
                    }
                });
            });
        } catch(e) {
            console.error('error on voucher creation', e)

            this.error = true;
            this.errorMessage = 'Error while creating vouchers';
        }

        this.loading = false;
    }

    printTicket(ticket) {
        if (!ticket.already_printed) {
            this.api.post(`rsvps/${ticket.rsvp_id}/tickets/${ticket.id}/print`).then(() => {
                ticket.already_printed = true;
            });
        }
    }

    downloadOverviewDocument() {
        this.invoiceActionsService.downloadVouchersOverviewDocument(this.invoice);
    }

    printOverviewDocument() {
        this.invoiceActionsService.printVouchersOverviewDocument(this.invoice).then(() => {
            this.sweetAlert.success('Print started', 'Started the print-job for the voucher overview.');
        });
    }

    printVouchers() {
        this.showVoucherPrintButton = false;
        this.api.post(`vouchers/print/invoice/${this.invoice.id}`).then(() => {
            this.sweetAlert.success('Print started', 'The print jobs has been started');
        }, () => {
            this.sweetAlert.success('Error', 'An error occurred while printing. Please retry');
            this.showVoucherPrintButton = true;
        })
    }
}

VouchersAndTicketsModalController.$inject = [
    '$uibModalInstance',
    'invoiceId',
    '$http',
    '$q',
    'InvoiceActionsService',
    'SweetAlert'
];

/**
 * @ngdoc object
 * @name billing.invoices.controller:VouchersAndTicketsModalController
 *
 * @description
 *
 */
angular
    .module('festzelt-os.billing.invoices')
    .controller('VouchersAndTicketsModalController', VouchersAndTicketsModalController);



// WEBPACK FOOTER //
// ./src/app/pages/billing/invoices/controllers/invoice-actions/vouchers-and-tickets-modal-controller.js